import { BaseSerializer } from "./baseSerializer.ts";
import { TodoList } from "@models/todo_list.model.ts"
import {TodoSectionSerializer} from "@models/serializers/todoSectionSerializer.ts";


export class TodoListSerializer extends BaseSerializer {

    public deserialize( data: any ): TodoList {

        const todo_list = new TodoList();
        this._copyAttributes(todo_list, data);

        if (data.sections) {
            const todoSectionSerializer = new TodoSectionSerializer();
            todo_list.sections = todoSectionSerializer.deserializeList(data.sections);
        }

        return todo_list;

    }

}
